export default "__VITE_ASSET__BCaKexFy__"